export default {
  step1: '基本資訊',
  step2: '產品屬性',
  step3: '規格/價格資訊',
  step4: '產品詳情',
  productName: '產品名稱',
  productNameRequired: '請輸入產品名稱',
  productNamePlaceholder: '請輸入產品名稱',
  productCategory: '產品分類',
  productNo: '產品編碼',
  productNoRequired: '請輸入產品編碼',
  productNoPlaceholder: '請輸入產品編碼',
  productImage: '產品圖片',
  productVideo: '產品影片',
  videoCover: '影片封面',
  videoCoverUpload: '影片封面',
  productWeight: '產品重量',
  weightPlaceholder: '請輸入產品重量',
  weightUnit: 'kg',
  productUnit: '產品單位',
  unitPlaceholder: '請輸入產品單位',
  productBarcode: '產品條碼',
  barcodePlaceholder: '請輸入產品條碼',
  productRetailPrice: '產品零售價',
  retailPricePlaceholder: '請輸入產品零售價',
  productMarketPrice: '產品市場價',
  marketPricePlaceholder: '請輸入產品市場價',
  productAttributes: '產品屬性：',
  attrGroup: '屬性組',
  attrValue: '屬性值',
  action: '操作',
  attrSelectPlaceholder: '請先選擇屬性',
  addAttr: '+ 增加一個',
  productSpec: '產品規格',
  singleSpec: '單規格',
  multiSpec: '多規格',
  productPrice: '產品價格',
  priceRequired: '請輸入產品價格',
  pricePlaceholder: '請輸入產品價格',
  priceUnit: 'USD',
  specNamePlaceholder: '規格名',
  specValuePlaceholder: '規格值',
  addSpecValue: '+ 新增',
  addSpec: '+ 添加規格',
  generateSpec: '+ 生成規格',
  applySpecChanges: '修改規格名稱',
  specImage: '規格圖片',
  specPrice: '價格(元)',
  specWeight: '產品重量',
  specVirtualSales: '虛擬銷量',
  specNo: '規格編號',
  specNoPlaceholder: '商品編號',
  specNoRequired: '規格編號不能為空',
  specImageRequired: '規格圖片不能為空',
  specMatrixRequired: '請先生成規格矩陣',
  select: '選擇',
  productDetail: '產品詳情',
  detailPlaceholder: '請輸入正文',
  phonePreview: '產品詳情',
};
